import React from 'react';

import HeaderComponent from '../../common/HeaderComponent/HeaderComponent';
import BottomAppBarComponent from '../../common/BottomAppBarComponent/BottomAppBarComponent';
import FooterComponent from '../../common/FooterComponent/FooterComponent';
import "./AboutusDetailsComponent.css";

import {
    Box,
    Container
} from '@mui/material';

export default function AboutusDetailsComponent() {

    return (
        <>
            <HeaderComponent />
            < Box className="puja-gallery-page">
                <Container sx={{ px: 1 }}>

                <div className='div-space'>
                <h3 class="puja-details">About us</h3>
                    <p class="sub-title">
                        Sarvamangala Sri Rajarajeswari Ashram is a 52 year old religious center based in Chennai, India.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                        Address: 18/29 16th Street, TG Nagar, Nanganallur, Chennai, INDIA 600061
                     </p>
                </div>

                <div className='text-container'>
                    <h3 class="puja-details">
                        A SRIVIDYA MANTRALAYAM 
                    </h3>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                        Just as Tirupati is of great importance to Vaishnavaites and Chidambaram to Saivaites, 
                        so also among Ambal temples, the Srividya Mantralayam Sarvamangala Sri Rajarajeswari temple established by Sri Rajagopala Swamiji holds an exceptional place.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                        However many temples there might be in existence for Sri Meenakshi, Madurai is her primary abode. 
                        Same with Sri Kamakshi, Kanchi is Her Mulasthanam. Likewise, Kasi for Sri Visalakshmi.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                        In the same vein, Sarvamangala Sri Rajarajeswari temple established by Swamiji, is the primary abode of Sri Rajarajeswari. 
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                        Famed for its temples and also nicknamed as 'temple town', 
                        Nanganallur in fact received its first temple through the establishment of Swamiji's Sri Rajarajeswari temple. 
                        Having achieved fame as “Nanganallur Sri Rajarajeswari”, many notable composers like Papanasam Sivan, Sri Lakshmikantha Sharma, Andavan Pichi Ammal have rendered wonderful hymns on this Ambal.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                       Sri Kanchi Maha Periyava very often advised people to visit Nanganallur Sri Rajarajeswari temple. 
                       Also, the Sringeri Acharya, Maha Sannidanam Abhinava Vidyathirtha stated that the present place of Nanganallur Sri Rajarajeswari, 
                       also happened to be the place where Ambal resided for several thousand years
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                        Swami Sastri who installed the Mahameru at Ramanashram in the presence of Bhagawan Sri Ramana Maharishi was the one who installed both Ambal as well as Mahameru at Sri Rajarajeswari temple.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                        The Siva Lingam for which puja was done by Sri Seshadri Swamigal resides in the Sri Rajarajeswari temple. 
                        Furthermore, the yoga dandam (staff) of Sri Suraikkai Swamigal is also present in the temple.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                       Nanganallur Sri Rajarajeswari inspired Papanasam Sivan and Andavan Pichi Ammal to spontaneously compose songs in Her presence, 
                       songs that are rich with fantastic effulgence of devotion.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                        Among the various forms of Ambal, the form of Sundari and Shodasi can be found only in Kanchi Kamakshi temple and Nanganallur Sri Rajarajeswari temple. 
                        In Sri Rajarajeswari temple Ambal isn't merely the wife of Lord Siva. She is the bestower of sakti to Trimurtis - Brahma, Vishnu & Siva.
                    </p>
                </div>
                
                <div className='div-space'>
                    <p class="sub-title">
                        After hosting her chief of the army, Akhilandeswari in Thiruvanaikaval temple and her minister Meenakshi in Madurai temple, 
                        Sri Lalita Mahatripurasundari is esconsed in the form of the Great Empress as Sri Rajarajeswari in Nanganallur temple.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                        In Nanganallur, Sridevi has brought about a temple that is built strictly according to Srividya tradition, with puja done to Her according to Srividya sastra.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                       Indeed, here is the speciality of Sri Rajarajeswari temple that Ambal made possible through Swamiji: 
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                       Ambal chose to manifest as a svaymabu murti, as an image unsculpted by human hands. The architecture of the Temple strictly follows Srividya conventions. 
                       She resides in Her full glory in this Temple, designed as per Her wish, and showers Her Grace to devotees
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                       Another reason for Her wish to have this special Temple is to propagate Srividya, the path of devotion to Her.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                       This is the only temple in the world that has been built & where worship is performed as per directions given in important Srividya texts such as Parasurama Kalpa Sutra.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                       This temple is a mantralayam, rich in yantras and subtle mantras. Each square inch of this temple is filled with yantra and mantra sakti. 
                       This temple's energisation (prathishtakrama) bears out the principles of Srividya sastra. The garbagraha of Ambal has been established on the lines of Mahashodasi mantra. 
                       The various aspects of the temple including the minutest of the physical configurations are in alignment with the time durations of mantra alphabets (aksharas).
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                      There are 43 triangles in Srichakra. Srichakra is known by the other name 'trichadvarim satkonam'. 
                      This is exactly what Adi Sankara states in the Soundarya Lahari sloka that starts as "chaturbhihi". 
                      14 triangles (chaturdasa), 20 triangles (10 bahir dasa and 10 anthar dasa), 8 triangles (ashta), one triangle (tri) - these make a total of 43 triangles.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                       43 triangles rising around the bindu is Mahameru. 
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                      Encompassing 43 triangles and in the place of bindu 43 sakti-yantras have been energised and Sridevi resides on top of the bindu. 
                      The main tower (rajagopuram) of the temple has been built on the basis of Durga Rahasya Tantra. 
                      Tithi Nitya Devata shrines found in Sri Rajarajeswari temple cannot be seen anywhere in the world.
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                      In order to behold Sridevi, one has to climb 16 steps. 
                      After the darsan, one has to climb down 16 steps. Each of the steps bears a Tithinitya-yantra.
                      Furthermore, each of the sixteen steps also en-shrine the energies of Mahashodasi mantra. 
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                      Also not seen anywhere in the world, here in temple, there is both, a specific yantra as well as murti for each of the Tithinitya devis - for whom daily puja is offered. 
                    </p>
                </div>

                <div className='div-space'>
                    <p class="sub-title">
                     It is the command of Sridevi that another temple like this Temple cannot be built. 
                     Indeed, Swamiji would very often say that "Even if I want to build a similar temple somewhere else, I will not be able to ".
                    </p>
                </div>

                </Container>
            </Box>

            <FooterComponent />
            <BottomAppBarComponent />
        </>
    )

}